import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule }   from '@angular/forms';

import { AppComponent } from './app.component';
import { UploadPage } from './pages/upload/upload.component';
import { LoginPage } from './pages/login/login.component';
import { RegisterPage } from './pages/register/register.component';
import { ThankyouPage } from './pages/thankyou/thankyou.component';
import { ConfirmPage } from './pages/confirm/confirm.component';
import { ForgotPage } from './pages/forgot/forgot.component';
import { ResetPage } from './pages/reset/reset.component';
import { DashboardPage } from './pages/dashboard/dashboard.component';
import { PolicyPage } from './pages/policy/policy.component';
import { TermsPage } from './pages/terms/terms.component';
import { ContactPage } from './pages/contact/contact.component';
import { CookiesPage } from './pages/cookies/cookies.component';
import { Error404Page } from './pages/error404/error404.component';


import { RouterModule }   from '@angular/router';
import { HttpModule }    from '@angular/http';

import { PreviewComponent } from './components/preview/preview.component';

import { FileDropDirective, FileSelectDirective } from 'ng2-file-upload';
import { DndModule } from 'ng2-dnd';
import { AuthService } from './pages/login/auth.service';
import { AuthGuard } from './pages/login/auth-guard.service';
import { NoAuthGuard } from './pages/login/noauth-guard.service';
import { AdminAuthGuard } from './pages/login/admin-guard.service';
import { ManagerAuthGuard } from './pages/login/manager-guard.service';
import { MaintainerAuthGuard } from './pages/login/maintainer-guard.service';
import { AnyAuthGuard } from './pages/login/any-auth-guard.service';

import { AdminDashboardPage } from './pages/admin/dashboard/dashboard.component';
import { OfflineStaticDevices } from './pages/admin/dashboard/offlinedevices';
import { OccupancyStaticDevices } from './pages/admin/dashboard/occupancydevices';
import { AdminApprovalPage } from './pages/admin/approval/approval.component';
import { AdminUsersPage } from './pages/admin/users/users.component';
import { AdminDevicesPage } from './pages/admin/devices/devices.component';
import { AdminDataMatchingPage } from './pages/admin/data-matching/data-matching.component';
import { LandingPage } from './pages/landing/landing.component';

import { AgmCoreModule } from '@agm/core';
import { environment } from '../environments/environment';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { OuterFocusDirective } from './directives/outer-focus.directive';
import { MultiselectDropdownModule } from 'angular-2-dropdown-multiselect';
import { SortableDirective } from './directives/sortable.directive';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BusyModule } from 'angular2-busy';
import { CurrencyMaskModule } from "ng2-currency-mask";
import { AdPreview } from  './pages/admin/approval/preview';
import { DevicePreview } from './pages/admin/devices/devicepreview';
import { DeviceEdit } from './pages/admin/devices/edit';
import { Profile } from  './pages/admin/users/profile';


import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';

import { CreditCardDirectivesModule } from 'angular-cc-library';
import { ProfilePage } from './pages/profile/profile.component';

import { ToastyModule } from 'ng2-toasty';
import { AboutComponent } from './pages/about/about.component';
import { FaqComponent } from './pages/faq/faq.component';

import { ScrollToModule } from 'ng2-scroll-to';

import { ShowMoreComponent } from './components/show-more/show-more.component';

import {TimeAgoPipe} from 'time-ago-pipe';
import { DragDirective } from './directives/drag.directive';

import { UiSwitchModule } from 'ngx-ui-switch';

import { MultiDatePicker } from './components/datepicker/multidate-picker';
import { KpiRectangleComponent } from './pages/dashboard/kpi-rectangle/kpi-rectangle.component';
import { DoughnutChartComponent } from './pages/dashboard/doughnut-chart/doughnut-chart.component';
import { HistogramComponent } from './pages/dashboard/histogram/histogram.component';
import { GenderSplitHistogramComponent } from './pages/dashboard/gender-split-histogram/gender-split-histogram.component';
import { ChartsModule } from 'ng2-charts';
import { BarChartComponent } from './pages/dashboard/bar-chart/bar-chart.component';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};

let routes = [
  {
    path: '',
    component: LandingPage,
    canActivate: [NoAuthGuard]
  },
  {
    path: 'login',
    component: LoginPage,
    canActivate: [NoAuthGuard]
  },
  {
    path: 'register',
    component: RegisterPage,
    canActivate: [NoAuthGuard]
  },
  {
    path: 'upload',
    component: UploadPage,
    canActivate: [AuthGuard]
  },
  {
    path: 'dashboard',
    component: DashboardPage,
    canActivate: [AuthGuard]
  },
  {
    path: 'profile',
    component: ProfilePage,
    canActivate: [AnyAuthGuard]
  },
  {
    path: 'thankyou',
    component: ThankyouPage,
    canActivate: [NoAuthGuard]
  },
  {
    path: 'confirm/:hash',
    component: ConfirmPage
  },
  {
    path: 'forgot',
    component: ForgotPage
  },
  {
    path: 'reset/:hash',
    component: ResetPage
  },
  {
    path: 'policy',
    component: PolicyPage
  },
  {
    path: 'cookies',
    component: CookiesPage
  },
  {
    path: 'terms',
    component: TermsPage
  },
  {
    path: 'contact',
    component: ContactPage
  },
  {
    path: 'about',
    component: AboutComponent
  },
  {
    path: 'faq',
    component: FaqComponent
  },
  {
    path: 'admin',
    component: AdminDashboardPage,
    canActivate: [AdminAuthGuard]
  },
  {
    path: 'admin/approval',
    component: AdminApprovalPage,
    canActivate: [ManagerAuthGuard]
  },
  {
    path: 'admin/users',
    component: AdminUsersPage,
    canActivate: [AdminAuthGuard]
  },
  {
    path: 'admin/devices',
    component: AdminDevicesPage,
    canActivate: [MaintainerAuthGuard]
  },
  {
    path: 'admin/data-matching',
    component: AdminDataMatchingPage,
    canActivate: [MaintainerAuthGuard]
  },
  {
    path: '**',
    component: Error404Page
  }
];

@NgModule({
  declarations: [
    AppComponent,
    UploadPage,
    LoginPage,
    RegisterPage,
    ThankyouPage,
    ConfirmPage,
    ForgotPage,
    ResetPage,
    DashboardPage,
    PolicyPage,
    TermsPage,
    ContactPage,
    ProfilePage,
    LandingPage,
    CookiesPage,
    Error404Page,

    AdminDashboardPage,
    AdminApprovalPage,
    AdminUsersPage,
    AdminDevicesPage,
    AdminDataMatchingPage,

    FileDropDirective,
    FileSelectDirective,
    PreviewComponent,
    OuterFocusDirective,
    SortableDirective,
    AdPreview,
    DevicePreview,
    DeviceEdit,
    OfflineStaticDevices,
    OccupancyStaticDevices,
    Profile,
    AboutComponent,
    FaqComponent,
    ShowMoreComponent,

    TimeAgoPipe,
    DragDirective,
    MultiDatePicker,

    KpiRectangleComponent,
    DoughnutChartComponent,
    HistogramComponent,
    GenderSplitHistogramComponent,
    BarChartComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    MultiselectDropdownModule,
    DndModule.forRoot(),
    RouterModule.forRoot(routes),
    AgmCoreModule.forRoot({
      apiKey: environment.google.apiKey
    }),
    NgbModule.forRoot(),
    BrowserAnimationsModule,
    BusyModule,
    CurrencyMaskModule,
    PerfectScrollbarModule,
    CreditCardDirectivesModule,
    ToastyModule.forRoot(),
    ScrollToModule.forRoot(),
    UiSwitchModule,
    ChartsModule
  ],
  entryComponents: [AdPreview, Profile, DevicePreview, DeviceEdit, OfflineStaticDevices, OccupancyStaticDevices],
  providers: [
    AuthService, AuthGuard, NoAuthGuard, AdminAuthGuard, AnyAuthGuard, ManagerAuthGuard, MaintainerAuthGuard,
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }





// WEBPACK FOOTER //
// /Users/gordan.o@nylas.com/Documents/GitHub/adluux/adluux-frontend/src/app/app.module.ts